import { render, staticRenderFns } from "./UserSubscriptionOrdersTable.vue?vue&type=template&id=74f21c90&"
import script from "./UserSubscriptionOrdersTable.vue?vue&type=script&lang=js&"
export * from "./UserSubscriptionOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports